import { Application } from "@core/Application";

import { SpecificEvents } from "./AnalyticsEvents";

export const trackAnalyticsSafely = (event: SpecificEvents) => {
    try {
        void Application.shared().coreDependencies.analytics.track(event).catch((error) => {
            console.error(error);
        });
    } catch (error) {
        console.error(error);
    }
};
